// © Microsoft Corporation. All rights reserved.

import { NavBar } from "./NavBar";
import { navBarTemplate as template } from "./NavBar.template";
import { brandingStyles, navBarStyles } from "./NavBar.styles";
import { customElement } from "@microsoft/fast-element";
import { NavigationItem } from "./Interfaces";
import { isWindowsFlightEnabled, WindowsFlights } from "@msnews/windows-shared";

const styles = isWindowsFlightEnabled(WindowsFlights.VerticalBranding1) ? [navBarStyles, brandingStyles] : navBarStyles;
@customElement({
    name: "msn-nav-bar",
    template,
    styles
})
export class MsnNavBar extends NavBar { }

export { NavigationItem };
export * from "./nav-item";
